// extracted by mini-css-extract-plugin
export default {"settings_modal":"TimeOffSettingsModal_settings_modal__87N2R","body":"TimeOffSettingsModal_body__VESGf"};